import {
  QBtn,
  QToolbar,
  QToolbarTitle,
  QCard,
  QCardSection,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QChip,
  QBanner,
  QSelect,
  QImg,
} from 'quasar';

export default {
  QBtn,
  QToolbar,
  QToolbarTitle,
  QCard,
  QCardSection,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QChip,
  QBanner,
  QSelect,
  QImg,
};
